/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { css, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import { media } from '@atlaskit/primitives/responsive';

const styles = css({
	display: 'block', // Prevents 5px of erroneous height under carousel panels on homepage
	width: '100%',
	minWidth: '0',
});

const desktopStyles = css({
	display: 'block',
	[media.below.xs]: {
		display: 'none',
	},
});
const mobileStyles = css({
	display: 'block',
	[media.above.xs]: {
		display: 'none',
	},
});

export const Image: ({
	src,
	srcMobile,
	alt,
}: {
	src: string;
	srcMobile?: string;
	alt: string;
}) => JSX.Element = ({ src, srcMobile, alt }: { src: string; srcMobile?: string; alt: string }) => (
	<React.Fragment>
		{srcMobile && <img css={[styles, mobileStyles]} src={srcMobile} alt={alt} />}
		<img css={[styles, srcMobile && desktopStyles]} src={src} alt={alt} />
	</React.Fragment>
);
